import { useEffect, useRef } from 'react';
import * as THREE from 'three';

export default function App() {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    
    const scene = new THREE.Scene();
    const w = window.innerWidth;
    const h = 600;
    const camera = new THREE.PerspectiveCamera(75, w / h, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    
    renderer.setSize(w, h);
    renderer.setClearColor(0x000000, 0.05);
    canvasRef.current.appendChild(renderer.domElement);
    
    camera.position.z = 4;

    const spheres = [];
    for (let i = 0; i < 7; i++) {
      const angle = (i / 7) * Math.PI * 2;
      const radius = 1.5;
      const geometry = new THREE.IcosahedronGeometry(0.3, 3);
      const material = new THREE.MeshPhongMaterial({ 
        color: i % 2 === 0 ? 0xA71930 : 0xC9A961,
        wireframe: true,
        emissive: i % 2 === 0 ? 0xA71930 : 0xC9A961,
        emissiveIntensity: 0.3
      });
      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.x = Math.cos(angle) * radius;
      mesh.position.y = Math.sin(angle) * radius;
      mesh.rotation.z = angle;
      scene.add(mesh);
      spheres.push({ mesh, angle, baseY: mesh.position.y });
    }

    const light = new THREE.PointLight(0xffffff, 1);
    light.position.set(5, 5, 5);
    scene.add(light);
    scene.add(new THREE.AmbientLight(0xffffff, 0.4));

    let scrollY = 0;
    const handleScroll = () => {
      scrollY = window.scrollY;
    };
    window.addEventListener('scroll', handleScroll);

    const animate = () => {
      requestAnimationFrame(animate);
      
      spheres.forEach((s, i) => {
        s.mesh.rotation.x += 0.005;
        s.mesh.rotation.y += 0.008;
        s.mesh.position.y = s.baseY + Math.sin(scrollY / 100 + i) * 0.3;
      });
      
      renderer.render(scene, camera);
    };
    animate();

    const handleResize = () => {
      camera.aspect = window.innerWidth / h;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, h);
    };
    window.addEventListener('resize', handleResize);
    
    const canvas = canvasRef.current;
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      if (canvas && renderer.domElement.parentNode === canvas) {
        canvas.removeChild(renderer.domElement);
      }
      renderer.dispose();
    };
  }, []);

  return (
    <div style={{ fontFamily: '"Lora", serif', background: '#FAF6F1', color: '#2B2B2B' }}>
      {/* NAV */}
      <nav style={{padding: '1.5rem 2rem', background: '#C41E3A', position: 'sticky', top: 0, zIndex: 100, display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.15)'}}>
        <h1 style={{margin: 0, fontSize: '32px', color: '#FAF6F1', fontFamily: '"Playfair Display", serif', fontWeight: 700, letterSpacing: '-2px'}}>Feelings</h1>
        <a href="#contact" style={{margin: 0, color: '#FAF6F1', fontSize: '11px', letterSpacing: '2.5px', textDecoration: 'none', cursor: 'pointer', fontWeight: 600}}>BOOK NOW</a>
      </nav>
      
      {/* HERO WITH 3D */}
      <section style={{height: '600px', background: '#2B2B2B', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden'}}>
        <div ref={canvasRef} style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} />
        <div style={{position: 'relative', zIndex: 10, textAlign: 'center', color: '#FAF6F1'}}>
          <p style={{margin: '0 0 1.5rem 0', fontSize: '11px', letterSpacing: '4px', color: '#D4AF37', fontWeight: 600}}>IMMERSIVE EXPERIENCES</p>
          <h1 style={{fontSize: '72px', margin: 0, fontFamily: '"Playfair Display", serif', fontWeight: 400, letterSpacing: '-3px'}}>Unforgettable</h1>
        </div>
      </section>

      {/* IMAGE FULL-BLEED 1 */}
      <section style={{height: '380px', background: `url('https://i.ibb.co/bMJTzQ3J/Whats-App-Image-2026-05-02-at-12-02-23.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative'}}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.2)'}} />
      </section>

      {/* TEXT SECTION */}
      <section style={{padding: '6rem 2rem', maxWidth: '900px', margin: '0 auto', background: '#FAF6F1'}}>
        <div style={{borderLeft: '5px solid #C41E3A', paddingLeft: '2.5rem'}}>
          <h2 style={{fontSize: '48px', margin: '0 0 1.5rem 0', fontFamily: '"Playfair Display", serif', color: '#C41E3A', fontWeight: 400, letterSpacing: '-1px'}}>What We Create</h2>
          <p style={{fontSize: '17px', lineHeight: 1.9, color: '#2B2B2B', margin: '0 0 1rem 0', fontWeight: 400}}>
            Events are theatrical productions. Every detail—from hanging flowers to ambient lighting—orchestrated to immerse your guests in a world you've imagined.
          </p>
          <p style={{fontSize: '15px', lineHeight: 1.8, color: '#555', margin: 0}}>
            Planning, décor, vendor management, on-site coordination. You focus on the moment. We handle the magic.
          </p>
        </div>
      </section>

      {/* IMAGE FULL-BLEED 2 */}
      <section style={{height: '420px', background: `url('https://i.ibb.co/1ftQnqGC/Whats-App-Image-2026-05-02-at-12-02-25.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', margin: '3rem 0'}}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(196,30,58,0.2)'}} />
      </section>

      {/* SERVICES */}
      <section style={{padding: '6rem 2rem', maxWidth: '1100px', margin: '0 auto', background: '#FAF6F1'}}>
        <h2 style={{textAlign: 'center', fontSize: '48px', margin: '0 0 4rem 0', fontFamily: '"Playfair Display", serif', color: '#2B2B2B', fontWeight: 400}}>Our Expertise</h2>
        <div style={{display: 'grid', gridTemplateColumns: window.innerWidth < 768 ? '1fr' : '1fr 1fr 1fr', gap: '4rem'}}>
          <div style={{paddingBottom: '1.5rem', borderBottom: '2px solid #D4AF37'}}>
            <h3 style={{fontSize: '18px', margin: '0 0 1rem 0', color: '#C41E3A', fontFamily: '"Playfair Display", serif', fontWeight: 400, letterSpacing: '-0.5px'}}>Weddings</h3>
            <p style={{fontSize: '13px', lineHeight: 1.8, color: '#555', margin: 0}}>Full-scale design. Ceremony to reception. Every element curated.</p>
          </div>
          <div style={{paddingBottom: '1.5rem', borderBottom: '2px solid #D4AF37'}}>
            <h3 style={{fontSize: '18px', margin: '0 0 1rem 0', color: '#C41E3A', fontFamily: '"Playfair Display", serif', fontWeight: 400, letterSpacing: '-0.5px'}}>Mehendi & Engagement</h3>
            <p style={{fontSize: '13px', lineHeight: 1.8, color: '#555', margin: 0}}>Vibrant celebrations. Flower installations, lighting, coordination.</p>
          </div>
          <div style={{paddingBottom: '1.5rem', borderBottom: '2px solid #D4AF37'}}>
            <h3 style={{fontSize: '18px', margin: '0 0 1rem 0', color: '#C41E3A', fontFamily: '"Playfair Display", serif', fontWeight: 400, letterSpacing: '-0.5px'}}>Home Décor</h3>
            <p style={{fontSize: '13px', lineHeight: 1.8, color: '#555', margin: 0}}>Personal spaces. Custom installations. Aesthetic reimagined.</p>
          </div>
        </div>
      </section>

      {/* IMAGE FULL-BLEED 3 */}
      <section style={{height: '400px', background: `url('https://i.ibb.co/DP14kxGw/Whats-App-Image-2026-05-02-at-12-02-26.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', margin: '3rem 0'}}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.15)'}} />
      </section>

      {/* IMAGE FULL-BLEED 4 */}
      <section style={{height: '420px', background: `url('https://i.ibb.co/Y4tH1tms/Whats-App-Image-2026-05-02-at-12-02-27.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', margin: '3rem 0'}}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(196,30,58,0.15)'}} />
      </section>

      {/* IMAGE FULL-BLEED 5 */}
      <section style={{height: '380px', background: `url('https://i.ibb.co/0jHXv9RB/Whats-App-Image-2026-05-02-at-12-02-28.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', margin: '3rem 0'}}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.1)'}} />
      </section>

      {/* CONTACT */}
      <section id="contact" style={{padding: '7rem 2rem', background: '#C41E3A', marginTop: '4rem'}}>
        <h2 style={{textAlign: 'center', fontSize: '48px', margin: '0 0 3.5rem 0', fontFamily: '"Playfair Display", serif', color: '#FAF6F1', fontWeight: 400}}>Let's Create</h2>
        <div style={{display: 'grid', gridTemplateColumns: window.innerWidth < 768 ? '1fr' : '1fr 1fr', gap: '5rem', maxWidth: '950px', margin: '0 auto'}}>
          
          <form style={{display: 'flex', flexDirection: 'column', gap: '1.5rem'}} onSubmit={(e) => { e.preventDefault(); alert('Inquiry received. We\'ll contact you within 24 hours.'); }}>
            <input type="text" placeholder="Name" required style={{padding: '14px 16px', border: 'none', fontSize: '14px', background: '#FAF6F1', color: '#2B2B2B', fontFamily: 'inherit'}} />
            <input type="email" placeholder="Email" required style={{padding: '14px 16px', border: 'none', fontSize: '14px', background: '#FAF6F1', color: '#2B2B2B', fontFamily: 'inherit'}} />
            <input type="text" placeholder="Event Type" style={{padding: '14px 16px', border: 'none', fontSize: '14px', background: '#FAF6F1', color: '#2B2B2B', fontFamily: 'inherit'}} />
            <textarea placeholder="Tell us about your vision" required style={{padding: '14px 16px', border: 'none', fontSize: '14px', minHeight: '100px', background: '#FAF6F1', color: '#2B2B2B', fontFamily: 'inherit', resize: 'none'}} />
            <button type="submit" style={{padding: '15px', background: '#FAF6F1', color: '#C41E3A', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 700, letterSpacing: '1.5px'}}>SEND INQUIRY</button>
          </form>

          <div style={{display: 'flex', flexDirection: 'column', gap: '3rem', paddingTop: '1rem'}}>
            <div>
              <p style={{margin: '0 0 0.7rem 0', color: '#D4AF37', fontSize: '10px', fontWeight: 700, letterSpacing: '2px'}}>PHONE</p>
              <p style={{margin: 0, color: '#FAF6F1', fontSize: '15px', fontFamily: '"Playfair Display", serif'}}>9822063414 / 9096885599</p>
            </div>
            <div>
              <p style={{margin: '0 0 0.7rem 0', color: '#D4AF37', fontSize: '10px', fontWeight: 700, letterSpacing: '2px'}}>EMAIL</p>
              <p style={{margin: 0, color: '#FAF6F1', fontSize: '15px', fontFamily: '"Playfair Display", serif'}}>feelingsflowers@gmail.com</p>
            </div>
            <div>
              <p style={{margin: '0 0 0.7rem 0', color: '#D4AF37', fontSize: '10px', fontWeight: 700, letterSpacing: '2px'}}>ADDRESS</p>
              <p style={{margin: 0, color: '#FAF6F1', fontSize: '13px', lineHeight: 1.8}}>203-204, Park Plaza<br/>Erandawana, Pune 411004</p>
            </div>
            <div>
              <p style={{margin: '0 0 0.7rem 0', color: '#D4AF37', fontSize: '10px', fontWeight: 700, letterSpacing: '2px'}}>INSTAGRAM</p>
              <p style={{margin: 0, color: '#FAF6F1', fontSize: '13px'}}>
                <a href="https://instagram.com/feelings.eventsanddecors" target="_blank" rel="noopener noreferrer" style={{color: '#D4AF37', textDecoration: 'none'}}>@feelings.eventsanddecors</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{padding: '2rem', textAlign: 'center', background: '#2B2B2B', color: '#D4AF37', fontSize: '11px', letterSpacing: '1px', fontWeight: 600}}>
        <p style={{margin: 0}}>© 2026 FEELINGS WEDDING DECOR</p>
      </footer>
    </div>
  );
}
